// Third-party
import classNames from 'classnames';
import React, { Component } from 'react';

// Constants
import { BMO_CONTACT_TYPE } from '../../../../utils/bmo-gif/constants';

// Components
import ContactDetailsEdit from './ContactDetailsEdit';
import ContactDetailsInfo from './ContactDetailsInfo';
import { userHasPermissionEnabled, PERMISSIONS } from '../../../../utils/permissions';
import { EditBMOContact } from '../../../components/bmo-gif';
import User from '@/types/user';
import Locale from '@/types/locale';
import GenericContact from '@/types/generic-contact';

type Props = {
  user: User;
  locale: Locale;
  contact: GenericContact;
  onSaveContact: (contact: GenericContact) => Promise<GenericContact>;
  onDeleteContact: () => void;
};

type State = {
  isEdited: boolean;
};

export default class ContactInfoCard extends Component<Props, State> {
  state = {
    isEdited: false,
  };

  onEditInfo = () => {
    this.setState({ isEdited: true });
  };

  onCancelEdit = () => {
    this.setState({ isEdited: false });
  };

  onBMOSaveContact = () => {
    this.setState({ isEdited: false });
  };

  onSaveContact = (contact: GenericContact) =>
    this.props.onSaveContact(contact).then(newContact => {
      this.setState({ isEdited: false });
      return newContact;
    });

  onDeleteContact = () => {
    this.props.onDeleteContact();
  };

  render() {
    const { contact, user, locale } = this.props;
    const { isEdited } = this.state;

    const isGIF = userHasPermissionEnabled(user, PERMISSIONS.BMO_GIF) && contact.type === BMO_CONTACT_TYPE;

    return (
      <div className={classNames('contact-info-card', { 'is-edited': isEdited })}>
        {!isEdited && (
          <ContactDetailsInfo user={user} isGIF={isGIF} locale={locale} contact={contact} onEdit={this.onEditInfo} onDelete={this.onDeleteContact} />
        )}

        {isEdited && isGIF && <EditBMOContact compact contact={contact} onSave={this.onBMOSaveContact} onCancel={this.onCancelEdit} />}

        {isEdited && !isGIF && <ContactDetailsEdit user={user} contact={contact} onCancel={this.onCancelEdit} onSave={this.onSaveContact} />}
      </div>
    );
  }
}
